"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const eventsModal_1 = require("./eventsModal");
const monitoring_icon_1 = require("@patternfly/react-icons/dist/js/icons/monitoring-icon");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const ViewClusterEventsButton = ({ cluster, onFetchEvents }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(eventsModal_1.EventsModalButton, { id: "cluster-events-button", entityKind: "cluster", icon: react_1.default.createElement(monitoring_icon_1.MonitoringIcon, null), cluster: cluster, title: "Cluster Events", variant: react_core_1.ButtonVariant.secondary, onFetchEvents: onFetchEvents }, t('ai:View cluster events')));
};
exports.default = ViewClusterEventsButton;
//# sourceMappingURL=ViewClusterEventsButton.js.map